import { atom, useAtom } from "jotai";

import { OptionType } from "#/types/options";

export const optionTypeAtom = atom<OptionType>("call");

export const useOptionType = () => {
  const [optionType, setOptionType] = useAtom(optionTypeAtom);

  return {
    optionType,
    setOptionType,
  };
};
